export default __webpack_public_path__ + "static/media/mir.143483e1.svg";